export enum AxisOrientation {
  Horizontal = 0,
  Vertical = 1
}
